import { Outlet } from "react-router";

const LoginLayout = () => {
  return <main>
    <Outlet />
  </main>;
};

export default LoginLayout;
